import { RouteRecordRaw } from 'vue-router';

const Layout = () => import('@/layout/index.vue');
const technologyRouter:RouteRecordRaw =  {
    path: '/technology/:code?/:selTid?',
    component: Layout,
    name: 'technology',
    children: [
        {
            path: '',
            name: 'technology-index', // 子路由的名称必须以父路由的名称座位起始字符串，为了匹配首页导航选中状态
            component: () => import('@/pages/technology/index.vue'),
            meta: {
                title: '核心技术'
            }
        }
    ]
};

export default technologyRouter;
